import { createAction, props } from '@ngrx/store';
import { Product, UniversityGallery } from '@uc/web/shared/data-models';

export const loadStateUniversityFailure = createAction(
	'[StateUniversity/API] Load StateUniversity Failure',
	props<any>(),
);

export const fetchUniversity = createAction(
	'[StateUniversity/API] Fetch University',
	props<{ universityUrl: string; product: Product }>(),
);

export const fetchClearingUniversity = createAction(
	'[StateUniversity/API] Fetch Clearing University',
	props<{ uniSlug: string }>(),
);

export const fetchUniByProduct = createAction(
	'[StateUniversity/API] Fetch Uni By Product',
	props<{ universityUrl: string; product: Product }>(),
);

export const fetchUniversityRatingStats = createAction(
	'[StateUniversity/API] Fetch University Rating Stats',
	props<{ universityUrl: string }>(),
);

export const updateUniversity = createAction(
	'[StateUniversity] Update University',
	props<any>(),
);

export const updateClearingUniversity = createAction(
	'[StateUniversity] Update Clearing University',
	props<any>(),
);

export const updateUniByProduct = createAction(
	'[StateUniversity] Update Uni By Product',
	props<any>(),
);

export const updateUniversityUrl = createAction(
	'[StateUniversity] Update University Url',
	props<any>(),
);

export const updateSavedProperty = createAction(
	'[StateUniversity] Update Saved Property',
	props<{ saved: boolean | number }>(),
);

export const updateUniversityRatingStats = createAction(
	'[StateUniversity] Update University Rating Stats',
	props<any>(),
);

export const loadMoreUniversityReviews = createAction(
	'[StateUniversity] Load More University Reviews',
	props<{ isLoadMore: boolean }>(),
);
